function NXCalenderStar({ className }: { className?: string }) {
  return (
    <svg
      className={className}
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      stroke="currentColor"
    >
      <g clipPath="url(#clip0_4227_3354)">
        <path
          d="M2.57143 3.42871C2.11677 3.42871 1.68074 3.60933 1.35925 3.93081C1.03776 4.25231 0.857147 4.68833 0.857147 5.143V21.4287C0.857147 21.8833 1.03776 22.3195 1.35925 22.6409C1.68074 22.9623 2.11677 23.143 2.57143 23.143H21.4286C21.8832 23.143 22.3193 22.9623 22.6407 22.6409C22.9622 22.3195 23.1429 21.8833 23.1429 21.4287V5.143C23.1429 4.68833 22.9622 4.25231 22.6407 3.93081C22.3193 3.60933 21.8832 3.42871 21.4286 3.42871H18"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M6 0.857178V6.00003"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M18 0.857178V6.00003"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M6 3.42871H14.5714"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M12.4264 7.97563L13.8606 10.8607C13.8926 10.9337 13.9435 10.9968 14.008 11.0437C14.0724 11.0906 14.1482 11.1195 14.2275 11.1275L17.4127 11.6112C17.5037 11.623 17.5896 11.6605 17.6601 11.7194C17.7307 11.7782 17.783 11.8559 17.8109 11.9433C17.8389 12.0308 17.8414 12.1244 17.8181 12.2133C17.795 12.3021 17.7468 12.3825 17.6796 12.445L15.3281 14.6797C15.2931 14.7465 15.2747 14.8209 15.2747 14.8965C15.2747 14.972 15.2931 15.0464 15.3281 15.1133L15.7784 18.2819C15.7976 18.3734 15.7898 18.4686 15.756 18.5558C15.7222 18.6431 15.6638 18.7187 15.5879 18.7734C15.512 18.8281 15.4218 18.8596 15.3283 18.8642C15.2349 18.8687 15.1421 18.8459 15.0613 18.7988L12.2262 17.2979C12.1529 17.2648 12.0733 17.2477 11.9928 17.2477C11.9123 17.2477 11.8327 17.2648 11.7593 17.2979L8.92426 18.7988C8.84345 18.8459 8.75067 18.8687 8.65721 18.8642C8.56373 18.8596 8.47357 18.8281 8.39766 18.7734C8.32175 18.7187 8.26335 18.6431 8.22954 18.5558C8.19572 18.4686 8.18795 18.3734 8.20717 18.2819L8.74081 15.1133C8.76377 15.0397 8.76815 14.9616 8.75362 14.886C8.73906 14.8103 8.70603 14.7394 8.65743 14.6797L6.30601 12.4283C6.24365 12.3651 6.19986 12.286 6.17948 12.1996C6.1591 12.1132 6.1629 12.0228 6.19045 11.9384C6.21802 11.854 6.26826 11.7789 6.33572 11.7211C6.40318 11.6634 6.48521 11.6253 6.57284 11.6112L9.7581 11.1442C9.83739 11.1362 9.91314 11.1073 9.9776 11.0604C10.0421 11.0135 10.0929 10.9503 10.125 10.8774L11.5592 7.99231C11.5976 7.91064 11.658 7.84134 11.7337 7.79222C11.8094 7.74312 11.8974 7.71618 11.9876 7.71444C12.0778 7.71271 12.1667 7.73625 12.2443 7.78242C12.3218 7.82856 12.3849 7.89549 12.4264 7.97563Z"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_4227_3354">
          <rect width="24" height="24" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
}

export default NXCalenderStar;
